import React, {useEffect, useRef, useState} from 'react';
import TablePage from "../../pages/tablePage/TablePage";
import SearchParams from "../../shared/components/common/SearchParams";
import {Button} from "antd";
import {buildUrl} from "../../shared/utils/net";
import toast from "react-hot-toast";
import {DownloadOutlined} from "@ant-design/icons";

const getDownloadUrl = (log, searchParam) => {
    const {logType, begin, end, userKey, pid} = searchParam;

    return `${process.env.REACT_APP_URL}exportCsv/large-csv/${logType}?begin=${begin}&end=${end}&userKey=${userKey || pid || ''}`;
}

const LogTemplate = ({columns, defaultSearchParams, routerUrl, searchParamVisible = true, log = 'default'}) => {
    const [searchParam, setSearchParam] = useState(defaultSearchParams);
    const [url, setUrl] = useState(buildUrl(routerUrl, searchParam));
    const [rowData, setRowData] = useState({});
    const [rows, setRows] = useState([]);

    const handleDownload = () => {
        const {begin, end} = searchParam;

        if (!begin || !end) {
            toast.error('시작일과 종료일을 모두 선택해주세요.');
            return;
        }
        
        window.location.href = getDownloadUrl(log, searchParam);
        toast.success('CSV 다운로드를 시작합니다...');
    };

    const refreshRef = useRef(null);

    useEffect(() => {
        setSearchParam(defaultSearchParams);
        setUrl(buildUrl(routerUrl, defaultSearchParams));
    }, [defaultSearchParams, routerUrl]);

    const handleSearch = () => {
        setUrl(buildUrl(routerUrl, searchParam));
    };

    const handleSearchChange = (name, value) => {
        if (name === 'type' && value === '') {
            setSearchParam(defaultSearchParams);
        } else {
            setSearchParam(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const resolvedColumns = typeof columns === 'function' ? columns(rows) : columns;

    const props = {
        columns: resolvedColumns,
        rowData,
        setRowData,
        setRows,
        refreshRef,
        url,
        searchParam
    }

    return (
        <div>
            {searchParamVisible && (
                <SearchParams
                    searchParam={searchParam}
                    handleSetSearchParam={handleSearchChange}
                    handleSearch={handleSearch}
                />
            )}
            <div style={{
                float: 'right',
                marginRight: 60,
                position: 'relative',
                zIndex: 1000
            }}>
                <Button
                    style={{
                        margin: 10,
                        backgroundColor: '#1890ff',
                        color: 'white',
                    }}
                    icon={<DownloadOutlined/>}
                    onClick={handleDownload}
                    disabled={searchParam.logType === 'log_admin'}
                >
                    CSV 다운로드
                </Button>
            </div>

            <TablePage {...props}/>
        </div>
    );
};

export default LogTemplate;
